import { Reveal, MaskedHeading, ParallaxImage } from "../Reveal";
import { STATS, IMAGES } from "../../data/content";

export default function Gilles() {
  return (
    <section className="section bg-pearl text-abyss py-24 md:py-40" data-testid="gilles-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <span className="chapter-num text-turquoise">CHAPITRE 08 — L'ORIGINE</span>

        <div className="mt-8 max-w-4xl">
          <MaskedHeading
            tag="h2"
            className="font-display font-medium text-[clamp(2.3rem,5vw,4.4rem)] leading-[1.02] tracking-tight text-abyss"
            lines={["Pourquoi cette Traversée ?"]}
          />
          <p className="font-display italic text-[clamp(1.4rem,3vw,2.2rem)] text-turquoise mt-2">
            Pourquoi les dauphins ? Pourquoi avec Gilles ?
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 mt-14 items-start">
          {/* Photographie réelle de Gilles */}
          <Reveal className="lg:col-span-4">
            <div className="relative">
              <ParallaxImage
                src={IMAGES.gilles}
                alt="Gilles Delieuze, portrait en forêt à la lumière dorée"
                className="aspect-[3/4] rounded-sm"
                amount={30}
              />
              <span className="absolute bottom-4 left-4 eyebrow text-pearl/90 bg-abyss/50 backdrop-blur-sm px-3 py-1 rounded-full">
                GILLES DELIEUZE
              </span>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-8 space-y-5 text-abyss/75 text-base md:text-lg leading-relaxed">
            <p>
              Depuis plus de vingt-cinq ans, Gilles Delieuze accompagne des femmes et des
              hommes dans leurs passages de vie, leurs transformations intérieures et leur
              relation à la conscience.
            </p>
            <p>
              Mais La Traversée ne vient pas uniquement d'une expérience professionnelle.
              Elle prend racine dans une rencontre ancienne.
            </p>
            <p>
              Depuis dix-neuf ans, Gilles chemine avec la présence symbolique et l'énergie
              des dauphins. Depuis onze ans, il accompagne également des groupes à leur
              rencontre physique, dans leur environnement naturel, notamment en Mer Rouge.
            </p>
            <p>
              Au fil de ces années, les dauphins ne sont pas devenus pour lui une image
              marketing ou un emblème décoratif. Ils sont devenus les représentants d'une
              intelligence du vivant qu'il cherche à transmettre : une intelligence qui
              relie la profondeur à la joie, la conscience au corps, l'individu au collectif
              et la transformation au mouvement.
            </p>
            <p className="text-turquoise">
              Gilles ne te demandera pas de croire à son expérience. Il t'invitera à
              vérifier ce qu'elle ouvre en toi.
            </p>
          </Reveal>
        </div>

        {/* Chiffres */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-abyss/10 mt-16 rounded-sm overflow-hidden">
          {STATS.map((s, i) => (
            <Reveal key={s.value} delay={i * 0.08} className="bg-pearl p-8 md:p-10 flex flex-col gap-2">
              <span className="font-display font-medium text-[clamp(3rem,6vw,5rem)] leading-none text-abyss">
                {s.value}
              </span>
              <span className="text-abyss/65 text-[0.95rem] leading-snug">{s.label}</span>
            </Reveal>
          ))}
        </div>

        <div className="grid lg:grid-cols-12 gap-10 mt-16 items-center">
          <Reveal className="lg:col-span-7 space-y-4 text-abyss/75 text-lg leading-relaxed">
            <p className="eyebrow text-abyss/45">LA TRAVERSÉE EST NÉE DE CETTE SYNTHÈSE</p>
            <ul className="space-y-2 text-abyss/80">
              <li>— vingt-cinq années d'accompagnement ;</li>
              <li>— dix-neuf années de cheminement avec les dauphins ;</li>
              <li>— onze années de rencontres physiques à leurs côtés ;</li>
              <li>
                — une approche reliant conscience, psychologie, spiritualité incarnée,
                philosophie, corps et intelligence du vivant.
              </li>
            </ul>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5">
            <p className="font-display text-2xl md:text-3xl leading-snug text-abyss">
              Pas pour te dire qui devenir. Pour t'aider à entendre ce qui, en toi, demande
              déjà à vivre.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
